<style scoped>
  #file-drag-drop {
    width: 100%;
  }
  form{
    display: block;
    /* height: 300px; */
    width: 100%;
    margin: auto;
    font-size: 22px;
    border: 3px solid #f8f8f8;
    margin-top: 10px;
    text-align: center;
    line-height: 100px;
    border-radius: 4px;
    overflow: hidden;
  }

  div.file-listing{
    width: 100%;
    margin: auto;
    padding: 10px;
    font-size: 15px;
  }

  div.file-listing img{
    height: 100px;
  }

  div.remove-container{
    text-align: center;
    line-height: 25px;
  }

  div.remove-container a{
    color: red;
    cursor: pointer;
  }

  .preview {
    margin: auto;
  }

  progress{
    width: 400px;
    margin: auto;
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
  }
</style>

<template>
  <div id="file-drag-drop">
    <form ref="fileform">
      <input type="file" ref="file" v-on:change="handleFileUpload()" style="display: none;"/>
      <input type="button" value="Seleziona o Trascina un file qui..." v-on:click="$refs.file.click()" />
      <div class="file-listing text-center" v-if="file && file.name">
        <vs-row vs-type="flex" vs-justify="space-around">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="8">
            <vs-button @click="removeFile($event)"
                       icon-pack="feather"
                       icon="icon-trash"
                       color="danger"
                       radius
                       type="border"
                       align="right"
                       size="large">
            </vs-button>
          </vs-col>
        </vs-row>
        <!-- <div class="remove-container">
          <a class="remove" v-on:click="removeFile($event)">Cancella</a>
        </div> -->
        <img class="preview text-sm" v-bind:ref="'preview'" style="display:none;"/>
        {{ file.name }}
      </div>
      <div v-else class="drop-files" style="min-height: 100px;"></div>
    </form>
    <progress v-if="uploadPercentage > 0" max="100" :value.prop="uploadPercentage"></progress>
  </div>
</template>

<script>
  export default {
    props: ['value'],
    /*
      Variables used by the drag and drop component
    */
    data(){
      return {
        dragAndDropCapable: false,
        uploadPercentage: 0,
        counter: 0,
        file: {}
      }
    },

    mounted(){

      this.file = this.value
      /*
        Determine if drag and drop functionality is capable in the browser
      */
      this.dragAndDropCapable = this.determineDragAndDropCapable();

      /*
        If drag and drop capable, then we continue to bind events to our elements.
      */
      if( this.dragAndDropCapable ){
        /*
          Listen to all of the drag events and bind an event listener to each
          for the fileform.
        */
        ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach( function( evt ) {
          /*
            For each event add an event listener that prevents the default action
            (opening the file in the browser) and stop the propagation of the event (so
            no other elements open the file in the browser)
          */
          this.$refs.fileform.addEventListener(evt, function(e){
            e.preventDefault();
            e.stopPropagation();
          }.bind(this), false);
        }.bind(this));

        /*
          Add an event listener for drop to the form
        */
        this.$refs.fileform.addEventListener('drop', function(e){
          /*
            Capture the files from the drop event and add them to our local files
            array.
          */
          for( let i = 0; i < e.dataTransfer.files.length; i++ ){
            this.file = e.dataTransfer.files[i] ;
            this.getImagePreviews();
          }
        }.bind(this));

        this.$refs.fileform.addEventListener("dragenter", function() {
          // highlight potential drop target when the draggable element enters it
            this.counter++;
            this.$refs.fileform.style['border-color'] = "#ccc";

        }.bind(this));

        this.$refs.fileform.addEventListener("dragleave", function() {
          // reset background of potential drop target when the draggable element leaves it
            this.counter--;
            if (this.counter === 0) {
                this.$refs.fileform.style['border-color'] = "";
            }

        }.bind(this));

        this.$refs.fileform.addEventListener("dragend", function() {
          // reset background of potential drop target when the draggable element leaves it
          this.counter--;
          this.$refs.fileform.style['border-color'] = "";

        }.bind(this));

        this.$refs.fileform.addEventListener("drop", function() {
          // reset background of potential drop target when the draggable element leaves it
          this.counter--;
          this.$refs.fileform.style['border-color'] = "";

        }.bind(this));
      }

    },

    methods: {
      handleFileUpload() {
        this.file = this.$refs.file.files[0]
        this.getImagePreviews()
      },
      /*
        Determines if the drag and drop functionality is in the
        window
      */
      determineDragAndDropCapable(){
        /*
          Create a test element to see if certain events
          are present that let us do drag and drop.
        */
        var div = document.createElement('div');

        /*
          Check to see if the `draggable` event is in the element
          or the `ondragstart` and `ondrop` events are in the element. If
          they are, then we have what we need for dragging and dropping files.

          We also check to see if the window has `FormData` and `FileReader` objects
          present so we can do our AJAX uploading
        */
        return ( ( 'draggable' in div )
                || ( 'ondragstart' in div && 'ondrop' in div ) )
                && 'FormData' in window
                && 'FileReader' in window;
      },

      /*
        Gets the image preview for the file.
      */
      getImagePreviews(){
        /*
          Iterate over all of the files and generate an image preview for each one.
        */
        if ( /\.(jpe?g|png|gif)$/i.test( this.file.name ) ) {
            /*
              Create a new FileReader object
            */
            let reader = new FileReader();

            /*
              Add an event listener for when the file has been loaded
              to update the src on the file preview.
            */
            reader.addEventListener("load", function(){
              this.$refs['preview'].src = reader.result;
            }.bind(this), false);

            /*
              Read the data for the file in through the reader. When it has
              been loaded, we listen to the event propagated and set the image
              src to what was loaded from the reader.
            */
            reader.readAsDataURL( this.file );
          }else{
            /*
              We do the next tick so the reference is bound and we can access it.
            */
            this.$nextTick(function(){
              this.$refs['preview'].src = '/images/file.png';
            });
          }
      },

      /*
        Removes a select file the user has uploaded
      */
      removeFile(ev){
        this.file = {}
        this.$refs['preview'].src = ""
        ev.stopPropagation()
      }
    },
    watch: {
      file(val) {
        this.$emit('input', val)
      }
    }
  }
</script>
